/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef, useState } from "react";
import { CameraControls, useGLTF } from "@react-three/drei";
import { ThreeEvent, useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";
import { Mesh } from "three";

const deg2Rad = (deg: number) => {
  return deg * (Math.PI / 180);
};

interface ISunCloudsProps {
  width: number;
}

export const DunceModel = ({ width }: ISunCloudsProps) => {
  const cameraStartPos = width < 800 ? 20 : 15;
  const { camera } = useThree();

  const [movement, setMovement] = useState(0);
  const [rotation, setRotation] = useState(0);

  camera.position.set(0, 0, cameraStartPos); // Set position like this
  //   camera.rotateX(deg2Rad(180)); // Rotate like this
  camera.lookAt(new THREE.Vector3(0, 0, 0)); // Set look at coordinate like this
  camera.layers.enable(1);

  const { scene } = useGLTF("/models/dunce.glb");

  const dunceRef = useRef<THREE.Group<THREE.Object3DEventMap>>(null!);

  //   const handlePointerUp = () => {
  //     setIsDragging(false);
  //   };

  useFrame((state, delta) => {
    // rotate from 0 to 180 and back every 5 seconds
    const time = state.clock.getElapsedTime();
    const rot = (Math.sin(((time + 15) / 20) * Math.PI * 2) + 1) / 2; // value between 0 and 1
    setRotation(((rot * Math.PI) / 3) * 2);
  });

  //   scene.setRotationFromEuler(new THREE.Euler(0, 0, 0));
  scene.scale.set(10, 10, 10);
  scene.position.set(2.2, -3, 0);

  const rangeHalf = 0.05;

  return (
    <group dispose={null} rotation={[0, rotation, 0]}>
      <CameraControls
        minPolarAngle={Math.PI / 2 - rangeHalf}
        maxPolarAngle={Math.PI / 2 + rangeHalf}
        minAzimuthAngle={0 - rangeHalf}
        maxAzimuthAngle={0 + rangeHalf}
        azimuthRotateSpeed={0.01}
        polarRotateSpeed={0.01}
        truckSpeed={0}
        minDistance={5}
      />

      <group ref={dunceRef} position={[0, 0, -2]}>
        <primitive object={scene} />
      </group>
    </group>
  );
};

useGLTF.preload("/models/dunce.glb");
